<template>
  <PopWidget title="信息反馈" @close="handleClosePop" @submit="handleSubmitInfo">
    <div>
      <div v-for="(item,index) in infoList" :key="index" class="flex justify-contet align-items">
        <div class="feed-item-label">{{ item.label }}</div>
        <img v-show="item.checked" @click="handleCheckItem(item)" src="../../assets/images/checked.png" />
        <img v-show="!item.checked" @click="handleCheckItem(item)" src="../../assets/images/not.png" />
          <!-- <img :src="item.checked ? '../../assets/images/checked.png' : '../../assets/images/not.png'"/> -->
      </div>
    </div>
    <textarea class="feedback-textarea" placeholder="请输入要反馈的信息" v-model="feedbackInfo.contentValue" v-if="feedbackInfo.contentKey == 'other'"></textarea>
  </PopWidget>
</template>
<script>
import feedbackHelper from '@/helpers/feedbackHelper'
// import hkjRadio from '@/components/radio.vue'
import PopWidget from './popWidget.vue'
// import RadioCell from 'vue-weui'
export default {
  name: 'feedBack',
  components: {
    // hkjRadio,
    PopWidget,
    // RadioCell
  },
  props: {
    skuId: String
  },
  data() {
    return {
      infoList: [],
      feedbackInfo: {},
      // checked:
    }
  },
  mounted() {
    this.feedbackInfo = { skuId: this.skuId }
    this.infoList = []
    feedbackHelper.feedbackItem( this )
  },
  methods: {
    handleClosePop() {
      this.$emit('close', {}, {})
    },
    handleSubmitInfo() {
        feedbackHelper.createFeedbackItem(this)
        this.$emit('close', {}, {})
    },
    handleCheckItem(item) {
      this.infoList = this.infoList.map(it => {
        return {
          label: it.label,
          value: it.value,
          checked: it.value===item.value?true: false
        }
      })
      this.feedbackInfo.contentKey = item.value
    }
  }
}
</script>
<style scoped>
.feed-item-label{
  font-size: 1rem;
  line-height: var(--len40);
  height: var(--len40);
  flex: 1;
  text-align: left;
}
.feedback-textarea{
     background-color: #ddd;
     border-radius: 5px;
     margin-top: 20px;
     width: 100%;
     text-align: left;
     height: 100px;
     padding: 5px;
     box-sizing: border-box;
     font-size: 14px;
}

img{
  width: var(--len20);
  height: var(--len20);
}
</style>